// Third-party library imports.
import React from 'react';
import PropTypes from 'prop-types';

// Local repo imports.
import PaletteHeader from './PaletteHeader';
import PaletteContent from './PaletteContent';
import Spinner from '../../atoms/Spinner';
import { renderIfElse } from '../../utils/helper';
import { CheckboxPaletteContext } from './CheckboxPalette.context';
import { EMPTY_ARRAY, EMPTY_OBJECT, NO_OP } from '../../constants/Constants';
import './CheckboxPalette.scss';
class CheckboxPalette extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.handleContentChange = (contentAccessor, rowIds, updatedActionData, subKeys, isSubAction) => {
      const {
        onPaletteChange
      } = this.props;
      const palette = {
        accessor: contentAccessor,
        keys: rowIds,
        action: updatedActionData,
        subKeys: subKeys,
        isSubAction: isSubAction
      };
      onPaletteChange(palette);
    };
    this.handleHeaderActionChange = (accessor, updatedActionData) => {
      const {
        paletteDatas,
        onPaletteChange
      } = this.props;
      const content = paletteDatas[accessor];
      const {
        subActions
      } = content[0];
      const palette = {
        accessor,
        keys: content.map(row => row.key),
        subKeys: subActions.map(row => row.key),
        action: updatedActionData
      };
      onPaletteChange(palette);
    };
  }
  render() {
    const {
      paletteHeaders,
      paletteDatas,
      paletteActions,
      loadingCheckboxPalette,
      onExpand
    } = this.props;
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderIfElse(loadingCheckboxPalette, () => /*#__PURE__*/React.createElement(Spinner, null), () => /*#__PURE__*/React.createElement("div", {
      className: "palette-container"
    }, paletteHeaders.map(header => /*#__PURE__*/React.createElement(CheckboxPaletteContext.Provider, {
      value: {
        paletteActions
      }
    }, /*#__PURE__*/React.createElement(PaletteHeader, {
      key: header === null || header === void 0 ? void 0 : header.key,
      id: header === null || header === void 0 ? void 0 : header.key,
      headerLabel: header === null || header === void 0 ? void 0 : header.label,
      accessor: header === null || header === void 0 ? void 0 : header.accessor,
      content: paletteDatas[header === null || header === void 0 ? void 0 : header.accessor],
      onHeaderActionChange: this.handleHeaderActionChange
    }), /*#__PURE__*/React.createElement(PaletteContent, {
      content: paletteDatas[header === null || header === void 0 ? void 0 : header.accessor],
      contentAccessor: header === null || header === void 0 ? void 0 : header.accessor,
      onContentChange: this.handleContentChange,
      onExpand: onExpand
    }))))));
  }
}
CheckboxPalette.propTypes = {
  loadingCheckboxPalette: PropTypes.bool,
  onPaletteChange: PropTypes.func,
  paletteActions: PropTypes.array,
  paletteDatas: PropTypes.object,
  paletteHeaders: PropTypes.array
};
CheckboxPalette.defaultProps = {
  loadingCheckboxPalette: false,
  onPaletteChange: NO_OP,
  paletteActions: EMPTY_ARRAY,
  paletteDatas: EMPTY_OBJECT,
  paletteHeaders: EMPTY_ARRAY
};
export default CheckboxPalette;